/** @format */

/** @format */

import React, {useEffect} from 'react';

export default function useGroupedByOrder() {
    const showGroupedByOrdersKey = 'showGroupedByOrders';

    const [showGroupedByOrders, setShowGroupedByOrders] = React.useState(false);

    useEffect(() => {
        if (localStorage.getItem(showGroupedByOrdersKey) !== null) {
            setShowGroupedByOrders(
                parseInt(localStorage.getItem(showGroupedByOrdersKey)) === 1 ? true : false
            );
        }
    }, []);

    const handleToggleGroupByOrders = () => {
        setShowGroupedByOrders(!showGroupedByOrders);
        localStorage.setItem(showGroupedByOrdersKey, !showGroupedByOrders ? 1 : 0);
    };

    return {
        showGroupedByOrders,
        handleToggleGroupByOrders
    };
}
